import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { MediaAgenciesPersonaPage } from "@/components/site/MediaAgenciesPersonaPage";
import { MEDIA_AGENCIES_META_DESCRIPTION } from "@/content/meta/MediaAgenciesPersonaPage";

export const Route = createFileRoute("/who-we-help/media-agencies")({
  head: () => ({
    meta: [
      { title: "Media Intelligence for Media Agencies | Perceptica" },
      { name: "description", content: MEDIA_AGENCIES_META_DESCRIPTION },
      { property: "og:title", content: "Media Intelligence for Media Agencies | Perceptica" },
      { property: "og:description", content: MEDIA_AGENCIES_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Media Intelligence for Media Agencies | Perceptica" },
      { name: "twitter:description", content: MEDIA_AGENCIES_META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/who-we-help/media-agencies" },
      ...ogImageMeta("en", "/who-we-help/media-agencies"),
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/who-we-help/media-agencies" }),
  }),
  component: MediaAgenciesPersonaPage,
});
